module.exports = __webpack_public_path__ + "img/layout-4.f7f536df.jpg";